import { appConstants } from "../helpers/actionType";
import { commonClass } from "../helpers/commonClass";

let user = null;
let appVar = null;
let pagemenu = null;
let regotp = null;
try {
    if (commonClass.decrypt) {
        try {
            user = commonClass.decrypt(localStorage.getItem('user'));
        }
        catch (ex) {
            user = localStorage.getItem('user')
        }
    }
    user = JSON.parse(user);
    user && !user.userid && localStorage.setItem('user', commonClass.encrypt(JSON.stringify({ userid: "0", username: "", mobileNo: "0", balance: "0", winbalance: "0", loginKey: "0", emailID: "", loginExpiry: 0, Imageinfo: " ", Created_date: "", Player_name: "", Country_code: "", bonus: "0", withdrawbalance: "0", kycstatus: "0", bonuswinning: '0', freecount: '0', Usertoken: '0' })));
    user = user && user.userid ? user : { userid: "0", username: "", mobileNo: "0", balance: "0", winbalance: "0", loginKey: "0", emailID: "", loginExpiry: 0, Imageinfo: " ", Created_date: "", Player_name: "", Country_code: "", kycstatus: "0", bonuswinning: '0', freecount: '0', Usertoken: '0' };
    appVar = JSON.parse(localStorage.getItem('appvariables'));
    // let Cvalue =commonClass.SetCountryCode();
    // appVar = appVar ? appVar : { countryCode: "", currency: Cvalue, version: process.env.REACT_APP_Version, bVersion: "0~0~0~0~0~0~0" };
    appVar = appVar ? appVar : { countryCode: "", currency: process.env.REACT_APP_CURRENCY, version: process.env.REACT_APP_Version, bVersion: "0~0~0~0~0~0~0~0" };
    pagemenu = localStorage.getItem('pagemenuid');
    pagemenu = pagemenu ? pagemenu : "0";
    regotp = JSON.parse(localStorage.getItem('regotp'));
    regotp = regotp ? regotp : {};
}
catch (ex) {
    user = user ? user : { userid: "0", username: "", mobileNo: "0", balance: "0", winbalance: "0", loginKey: "0", emailID: "", loginExpiry: 0, Imageinfo: " ", Created_date: "", login_Time: 0, bonus: "0", withdrawbalance: "0", kycstatus: "0", bonuswinning: '0', freecount: '0', Usertoken: '0' };
    appVar = appVar ? appVar : { countryCode: process.env.REACT_APP_Countrycode, currency: process.env.REACT_APP_CURRENCY, version: process.env.REACT_APP_Version, bVersion: "0~0~0~0~0~0~0~0" };
    pagemenu = pagemenu ? pagemenu : "0";
    localStorage.setItem('user', commonClass.encrypt(JSON.stringify(user)));
}
const initialState = {
    loggedIn: true, user, appvariables: appVar,
    pageFlog: 0, pageMenuID: pagemenu, LightBoxID: 0, otp: regotp,
    suggestuserid: ""
};
export const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case appConstants.LOGIN_SUCCESS:
            let Appvalue = state.appvariables;
            // 62 == indonesian,971 == Dubai,66 == Thailand, (Load currency based on login country)
            // if (action.userdata.Country_code == '62' || action.userdata.Country_code == '971' || action.userdata.Country_code == '66') {
            // Remove MultiCurrency
            // let CountryCode = commonClass.LoadCountry();
            // if (CountryCode && CountryCode.length > 0) {
            //     // After login Country based on load Currency. 
            //     let get_code_obj = CountryCode.filter(a => a.country_code == action.userdata.Country_code);
            //     if (get_code_obj && get_code_obj.length > 0) {
            //         localStorage.setItem('setuserCurrencynew', JSON.stringify(get_code_obj[0]))
            //         Appvalue = { ...Appvalue, currency: get_code_obj[0].symbol }
            //         localStorage.setItem('appvariables', JSON.stringify(Appvalue));
            //     }
            //     else {
            //         // default Country load to After Login.
            //         let get_code_obj = CountryCode.filter(a => a.country_code == '971');
            //         if (get_code_obj && get_code_obj.length > 0) {
            //             localStorage.setItem('setuserCurrencynew', JSON.stringify(get_code_obj[0]))
            //             Appvalue = { ...Appvalue, currency: get_code_obj[0].symbol }
            //             localStorage.setItem('appvariables', JSON.stringify(Appvalue));
            //         }
            //     }
            // }
            // }
            return {
                ...state,
                user: action.userdata,
                appvariables: Appvalue
            };
        case appConstants.LOGIN_ERROR:
            return {
                pageFlog: state.pageFlog,
                appvariables: state.appvariables
            };
        case appConstants.SET_PAGEID:
            return {
                ...state,
                LightBoxID: action.pageFlog
            };
        case appConstants.SET_LOGIN_OTP:
            localStorage.setItem('regotp', JSON.stringify(action.otp))
            return {
                ...state,
                otp: action.otp
            };
        case appConstants.LOGOUT:
            //for reload cart value
            let _lastloginmycart = JSON.parse(localStorage.getItem('lastloginmycart'))
            if (!_lastloginmycart) {
                localStorage.setItem('lastloginmycart', localStorage.getItem('mycart'));
            }
            localStorage.removeItem('mycart');
            let SetLogoutUser = { userid: "0", username: "", mobileNo: "0", balance: "0", bonus: "0", withdrawbalance: "0", winbalance: "0", loginKey: "0", emailID: "", loginExpiry: 0, Imageinfo: " ", Created_date: "", Player_name: "", Country_code: process.env.REACT_APP_Countrycode };
            localStorage.setItem('user', commonClass.encrypt(JSON.stringify(SetLogoutUser)));
            return {
                user: SetLogoutUser,
                pageFlog: state.pageFlog,
                appvariables: state.appvariables
            };
        case appConstants.GET_BALANCE:
            let userdata = state.user;
            if (userdata != undefined) {
                if (action.balance >= 0) {
                    userdata.balance = (parseFloat(action.balance) / 100); //31//
                }
                if (action.winbalance >= 0) {
                    userdata.winbalance = (parseFloat(action.winbalance) / 100);
                }
                if (action.bonus >= 0) {
                    userdata.bonus = (parseFloat(action.bonus) / 100);
                }
                if (action.bonuswinning >= 0) {
                    userdata.bonuswinning = (parseFloat(action.bonuswinning) / 100);
                }
                if (action.freecount >= 0) {
                    userdata.freecount = action.freecount
                }
                if (action.only_wallet >= 0) {
                    userdata.only_wallet = (parseFloat(action.only_wallet) / 100);
                }

                localStorage.setItem('user', commonClass.encrypt(JSON.stringify(userdata)));
            }
            return {
                ...state,
                user: { ...state.user, balance: userdata.balance, winbalance: userdata.winbalance, bonus: userdata.bonus, only_wallet: userdata.only_wallet, bonuswinning: userdata.bonuswinning, freecount: userdata.freecount }
            };

        case appConstants.UPDATE_KYC:
            let user_data = state.user;
            if (user_data != undefined) {
                user_data.kycstatus = action.details.kyc_status
                localStorage.setItem('user', commonClass.encrypt(JSON.stringify(user_data)));
            }
            return {
                ...state,
                user: { ...state.user, kycstatus: user_data.kycstatus }
            };
        case appConstants.UPDATE_BALANCE:
            let userdata1 = state.user;
            if (userdata1 != undefined) {
                let win_amt;
                if (action.data.flag == "1") {
                    win_amt = action.data.winning;
                    userdata1.balance = parseFloat(action.data.credit);
                }
                else if (action.data.flag == "2") {
                    userdata1.winbalance = parseFloat(win_amt)
                }
                // userdata1.winbalance = parseFloat(action.winbalance) ;
                localStorage.setItem('user', commonClass.encrypt(JSON.stringify(userdata1)));
            }
            return {
                ...state,
                user: { ...state.user, balance: userdata1.balance, winbalance: userdata1.winbalance }
            };
        case appConstants.UPDATE_PROFILE_IMG:
            let ouser = state.user;
            if (ouser != undefined) {
                ouser.Imageinfo = action.img;
                ouser.Player_name = action.name;
                ouser.emailID = action.email;
                localStorage.setItem('user', commonClass.encrypt(JSON.stringify(ouser)));
            }
            return {
                ...state,
                user: { ...state.user, Imageinfo: ouser.Imageinfo, Player_name: ouser.Player_name, emailID: action.email }
            };
        case appConstants.GET_BANNER_VERSION:
            let appVarl = state.appvariables;
            if (appVarl != undefined) {
                appVarl.bVersion = action.gbanner;//home banner ~ winner ~ promotion ~ past draw show
                localStorage.setItem('appvariables', JSON.stringify(appVarl));
            }
            return {
                ...state,
                appvariables: { ...state.appvariables, bVersion: action.gbanner }
            };
        case appConstants.GET_USER_CURRENCY:
            let appVarlc = state.appvariables;
            if (appVarlc != undefined) {
                // Set User Select Currency set Only Symbol For Currency
                appVarlc.currency = action.currency.symbol;
                //appVarlc.currency = action.currency.code; 
                localStorage.setItem('appvariables', JSON.stringify(appVarlc));
            }
            return {
                ...state,
                appvariables: { ...state.appvariables, currency: action.currency.symbol }
            };
        case appConstants.GET_CHANGE_PASSWORD:
            return {
                ...state,
                Changepassdetails: action.user
            }
        case appConstants.SUGGESTION_USERID:
            return {
                ...state,
                suggestuserid: action.suggest
            }
        default:
            return { ...state }
    }
}